import React, { useEffect, useRef, useState } from 'react';
import { KeyboardReact } from 'react-simple-keyboard';
import { TextField } from '@radix-ui/themes';
import { KeyboardReactInterface } from 'react-simple-keyboard/build/interfaces';
import useKeyboard from '../../contexts/keyboard/KeyboardContext';


const numericLayout = {
  default: ['1 2 3', '4 5 6', '7 8 9', '+ 0 *', '{bksp} {enter}'],
}

export const Keyboard = () => {
  const keyboardContext = useKeyboard()
  const [input, setInput] = useState('');
  const keyboardRef = useRef<KeyboardReactInterface>();
  const [shiftOn, setShiftOn] = useState<boolean>(false)

  useEffect(() => {
    if (keyboardContext.inputRef) {
      setInput(keyboardContext.inputRef.value)

      if(keyboardRef.current) {
        keyboardRef.current.setInput(keyboardContext.inputRef.value);
      }
    }

    const keyboardHolder = document.getElementById('virtual-keyboard')

    const clickCallback = (event: MouseEvent) => {
      // @ts-expect-error invalid type
      if (!keyboardHolder?.contains(event.target)) {
        keyboardContext.close()
      }
    }

    document.removeEventListener('click', clickCallback)
    setTimeout(() => {
      document.addEventListener('click', clickCallback);
    }, 100)
    return () => {
      document.removeEventListener('click', clickCallback)
    }
  }, [])

  const onChange = (input: any) => {
    setInput(input);
    if(keyboardContext.inputRef) {
      keyboardContext.inputRef.value = input
      keyboardContext.input?.props.onChange({
        target: {
          value: input,
        },
      })
    }
  };

  const handleEnter = () => {
    if(keyboardContext.inputRef) {
      keyboardContext.inputRef.value = input
      keyboardContext.input?.props.onChange({
        target: {
          value: input,
        },
      })
    }

    keyboardContext.close()
  }

  const handleShift = (button: string) => {
    const currentLayout = keyboardRef.current?.options.layoutName;
    const shiftToggle = currentLayout === 'default' ? 'shift' : 'default';
    if (button === '{shift}') {
      setShiftOn(currentLayout === 'default')
    }

    keyboardRef.current?.setOptions({
      layoutName: shiftToggle,
    });
  }

  const onKeyPress = (button: any) => {
    if (button === '{enter}') {
      handleEnter()
    } else if (button === '{shift}' || button === '{lock}') {
      handleShift(button);
    } else if (shiftOn) {
      keyboardRef.current?.setOptions({
        layoutName: 'default',
      });
      setShiftOn(false)
    }
  };

  const width = keyboardContext.layout === 'numeric' ? 'w-[20%]' : 'w-[60%]'
    
  return ( 
    <div className={'z-10 fixed w-full h-full'} style={{ backgroundColor: 'rgba(255, 255, 255, 0.97)' }}>
      <div className={`fixed ${width} left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2`} id="virtual-keyboard">
        {keyboardContext.title && <div className="text-center text-lg pb-3">{keyboardContext.title}</div>}
        <div>
          <TextField.Root
            value={input}
          />
        </div>

        <KeyboardReact
          keyboardRef={r => (keyboardRef.current = r)}
          onChange={onChange}
          onKeyPress={onKeyPress}
          layout={keyboardContext.layout === 'numeric' ? numericLayout : undefined}
        />
      </div>
    </div>
  )
}